import { request } from './request'

//作品列表
export function productPage(data) {
    return request({
        url: "/product/page",
        method: 'post',
        data
    })
}

//作品详情
export function productGet(id) {
    return request({
        url: "/product/get/" + id,
        method: 'post',
    })
}

//画院寺院列表
export function templePage(data) {
    return request({
        url: "/temple/page",
        method: 'post',
        data
    })
}

//画院详情
export function templeGet(id) {
    return request({
        url: "/temple/get/" + id,
        method: 'post',
    })
}

//文创商品列表
export function goodsPage(data) {
    return request({
        url: "/goods/page",
        method: 'post',
        data
    })
}

//文创商品详情
export function goodsGet(id) {
    return request({
        url: "/goods/get/" + id,
        method: 'post',
    })
}

//文创定制
export function orderSet(data) {
    return request({
        url: "/order/set",
        method: 'post',
        data
    })
}

//登录
// export function login(data) {
//     return request({
//         url: "/receptionIn",
//         method: 'post',
//         data
//     })
// }
export function login(data) {
    return request({
        url: "/reception/login",
        method: 'post',
        data
    })
}

// 获取用户信息
export function userInfo() {
    return request({
        url: "/user/get_user_info",
        method: 'get'
    })
}

//退出
export function logout() {
    return request({
        url: '/logout',
        method: 'post'
    })
}

// 新闻列表
export function noticePage(data) {
    return request({
        url: '/notice/page',
        method: 'post',
        data
    })
}

// 新闻详情
export function noticeDetail(id) {
    return request({
        url: `/notice/get/${id}`,
        method: 'post',
    })
}

// 设计元素列表
export function sourceImgPage(data) {
    return request({
        url: '/source/sourceImgPage',
        method: 'post',
        data
    })
}

//上传图片
export function picList(data) {
    return request({
        url: '/upload',
        method: 'post',
        data
    })
}

//生成图片
export function newPic(data) {
    return request({
        url: '/pytorch/transform',
        method: 'post',
        data
    })
} 

//通过画院查找传承人
export function inheritorListByTemple(id) {
    return request({
        url: `/inheritor/listByTemple/${id}`,
        method: 'post',
    })
} 

//传承人
export function peoPle(data) {
    return request({
        url: '/inheritor/page',
        method: 'post',
        data
    })
}   

//传承人分页
export function inherit(data) {
    return request({
        url: '/inheritor/page',
        method: 'post',
        data
    })
}   
//传承人详情
export function inheritDetail(id) {
    return request({
        url: `/inheritor/get/${id}`,
        method: 'post',
    })
}   

// 统计
export function visitCountGet(data) {
    return request({
        url: '/visit/count/get',
        method: 'post',
        data
    })
} 
